import React, { useState } from 'react'
import _ from 'lodash'
import { compose } from 'recompose'
import { Form, Input, message } from 'antd'
import { inject } from 'mobx-react'
import { Query, graphql } from 'react-apollo'
import gql from 'graphql-tag'
import Checkbox from '../../../../components/Custom/CustomCheckbox'

const GET_SETTINGS = gql`
    query barangaySettingsByCode(
		$barangay_uid: String,
		$code: String
	) {
		barangaySettingsByCode(
			barangay_uid: $barangay_uid,
			code: $code
		)
    }
`

const SET_OR_VALIDATION = gql`
    mutation setORValidation(
        $input: JSON
    ) {
        setORValidation(
            input: $input
        )
    }
`

const ORValidation = (props) => {
	const { 
		AuthStore, form, saveORValidation, ...rest 
	} = props
	const { getFieldDecorator, resetFields } = form
	const { barangay_uid } = AuthStore
	const [isSaving, setSaving] = useState(false)
    
	const handleSubmit = (e) => {
		e.preventDefault()
		form.validateFields((err, values) => {
			if (err) {
				return false
			}
            
			values = Object.assign({}, values, { 
				barangay_uid, 
				code: 'OR_VALIDATION', 
				is_required: values.is_required ? '1' : '0' 
			})

			message.loading({ key: 'set_or_validation', content: 'Saving OR validation, please wait..' })
			setSaving(true)
			saveORValidation(values).then((response) => {
				setSaving(false)
				message.success({ key: 'set_or_validation', content: 'OR validation successfully saved.' })
			}).catch(err => {
				setSaving(false)
				console.log('error saving or validation')
				message.error({ key: 'set_or_validation', content: err.message.replace('GraphQL error:', '') })
				resetFields()
			})
		})
	}

	return (
		<Query query={GET_SETTINGS} variables={{ barangay_uid, code: 'OR_VALIDATION' }}>
			{({ loading, error, data }) => {

				const mSetting = _.has(data, 'barangaySettingsByCode') ? data.barangaySettingsByCode : {}
				return (
					<div style={{ position: 'relative' }}>
						<Form onSubmit={handleSubmit}>
							<Form.Item label=''>
								{ getFieldDecorator('is_required', {
									initialValue: _.isEqual(mSetting.value, '1') ? true : false,
									rules: [{
										required: true,
										message: 'This field is required.'
									}]
								})
								(
									<Checkbox>{mSetting.label}</Checkbox>
								)}
							</Form.Item>
						</Form>
						<button disabled={isSaving} onClick={handleSubmit} style={{ position: 'absolute', top: '0px', right: '1px' }} type="button" className="btn btn-primary waves-effect waves-light">Save</button>
					</div>
				)
			}}
		</Query>
	)
}

const composed = compose(
	Form.create({ name: 'form-or-validation' }),
	inject('AuthStore'),
	graphql(SET_OR_VALIDATION, {
		props({ mutate }) {
			return {
				saveORValidation(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['barangaySettingsByCode']
					})
				}
			}
		}
	}),
)

export default composed(ORValidation)